define(['app/controllers/Controller', 'app/helpers/validator'], function (
    Controller,
    Validator
) {
    function NewsletterController() {
        var validator = false;

        function init() {
            validator = new Validator();
            validator.setPage('standard');
            setEvents();
        }

        function setEvents() {
            $('#newsletter button').on('click', function () {
                var that = $(this);
                var opt = that.hasClass('opt-in') ? 'in' : 'out';

                var media = 'email';
                if (that.hasClass('phone')) {
                    media = 'phone';
                }

                var input = $('input#' + media);
                var value = input.val();

                if (!validator.validate(media, value)) {
                    input.addClass('error');
                    partyking.common.models.messages.warning(
                        'inline',
                        'Formuläret är inte rätt ifyllt'
                    );
                    return false;
                } else {
                    input.removeClass('error');
                }

                if (opt == 'in') {
                    subscribe(media, value);
                } else {
                    unsubscribe(media, value);
                }
            });
        }

        function subscribe(media, value) {
            var url = '/newsletter/' + media + '/' + value + '/subscribe';

            $.get(
                url,
                function (result) {
                    if (result.success == 1) {
                        if (media == 'email') {
                            partyking.common.models.messages.message(
                                'inline',
                                'Anmälan lyckades! Ni premunerar nu på vårat nyhetsbrev per epost.'
                            );
                        } else {
                            partyking.common.models.messages.message(
                                'inline',
                                'Anmälan lyckades! Ni premunerar nu på vårat nyhetsbrev per sms.'
                            );
                        }
                    } else {
                        if (media == 'email') {
                            partyking.common.models.messages.message(
                                'inline',
                                'Ni prenumererar redan på vårat nyhetsbrev per epost.'
                            );
                        } else {
                            partyking.common.models.messages.message(
                                'inline',
                                'Ni prenumererar redan på vårat nyhetsbrev per sms.'
                            );
                        }
                    }
                },
                'json'
            );
        }

        function unsubscribe(media, value) {
            var url = '/newsletter/' + media + '/' + value + '/unsubscribe';

            $.get(
                url,
                function (result) {
                    if (result.success == 1) {
                        partyking.common.models.messages.message(
                            'inline',
                            'Avanmälningen lyckades!'
                        );
                    } else {
                        // Here we need to check the error code.
                        if (result.success == 0) {
                            if (media == 'email') {
                                partyking.common.models.messages.message(
                                    'inline',
                                    'Den mejladress du angav är redan avanmäld från vårt nyhetsbrev.'
                                );
                            } else {
                                partyking.common.models.messages.message(
                                    'inline',
                                    'Det telefonnummer du angav är redan avanmält från vårt nyhetsbrev.'
                                );
                            }
                        } else {
                            if (media == 'email') {
                                partyking.common.models.messages.message(
                                    'inline',
                                    'Avanmälningen misslyckades. Kontrollera dina uppgifter eller kontakta kundtjänst för vidare hjälp!'
                                );
                            } else {
                                partyking.common.models.messages.message(
                                    'inline',
                                    'Avanmälningen för SMS hittar inte ditt nummer. Kontrollera dina uppgifter eller kontakta kundtjänst för vidare hjälp!'
                                );
                            }
                        }
                    }
                },
                'json'
            );
        }

        init();
    }

    return NewsletterController;
});
